module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("©2023 Scott L. Mingus Sr. and Eric J. Wittenberg")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copys"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Names: Mingus, Scott L., Sr., author. | Wittenberg, Eric J., 1961- author.")]), _vm._v(" "), _c('p', {
    staticClass: "copyn1"
  }, [_vm._v("Title: “If We are Striking for Pennsylvania”: The Army of Northern Virginia and Army of the Potomac March to Gettysburg / Scott L. Mingus Sr., Eric J. Wittenberg.")]), _vm._v(" "), _c('p', {
    staticClass: "copyn2"
  }, [_vm._v("Description: First edition | El Dorado Hills: Savas Beatie, 2022 | Includes bibliographical references and index. Contents v. 1: June 3 - June 21, 1863. v. 2: June 22 - June 30, 1863 |")]), _vm._v(" "), _c('p', {
    staticClass: "copyn1"
  }, [_vm._v("Summary: “Scott L. Mingus Sr. and Eric J. Wittenberg, the authors of more than forty Civil War books, have once again teamed up to present a history of the opening moves of the Gettysburg Campaign in the two-volume study “If We Are Striking For Pennsylvania.” This compelling study is one of the first to integrate the military, media, political, social, economic, and civilian perspectives with rank-and-file accounts from the soldiers of both armies as they inexorably march toward their destiny at Gettysburg. This first installment covers June 3-21, 1863, while the second, spanning June 22-30, completes the march and carries the armies to the eve of the Fighting.” — Provided by publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyn2"
  }, [_vm._v("Identifiers: LCCN 2022016968 | ISBN 9781611215847 (v. 1 alk. paper) | ISBN 9781611215854 (v. 1 ebk.)")]), _vm._v(" "), _c('p', {
    staticClass: "copyn2"
  }, [_vm._v("ISBN 9781611216110 (v. 2 alk. paper) | ISBN 9781611216127 (v. 2 ebk.) | ISBN 9781611216127 (mobi)")]), _vm._v(" "), _c('p', {
    staticClass: "copyn2"
  }, [_vm._v("Subjects: LCSH: Gettysburg Campaign, 1863. | United States. Army of the Potomac. | Confederate States of America. Army. Department of Northern Virginia. | Soldiers–United States–Anecdotes. | Soldiers–Confederate States of America–Anecdotes. | United States–History–Civil War, 1861-1865–Regimental histories. Classification: LCC E475.51 .M558 2022 | DDC 973.7/349–dc23/eng/20220506")]), _vm._v(" "), _c('p', {
    staticClass: "copyn2"
  }, [_vm._v("LC record available at "), _c('span', {
    staticClass: "weblink"
  }, [_c('span', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "href": "http://www.lccn.loc.gov/2022016968",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2022016968")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("First Edition, First Printing")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerc"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Savas Beatie")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("989 Governor Drive, Suite 102")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("El Dorado Hills, CA 95762")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("916-941-6896 / "), _c('span', {
    staticClass: "weblink"
  }, [_c('span', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "href": "mailto:sales@savasbeatie.com"
    }
  }, [_vm._v("sales@savasbeatie.com")])])]), _vm._v(" / "), _c('span', {
    staticClass: "weblink"
  }, [_c('span', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "href": "http://www.savasbeatie.com",
      "target": "_blank"
    }
  }, [_vm._v("www.savasbeatie.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All of our titles are available at special discount rates for bulk purchases in the United States. Contact us for information.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e47656","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Copyright.vue
// module id = 60
// module chunks = 0